import uniq from 'lodash/uniq'

export function formatAnalyticsIndex(index: number) {
  return index === -1 ? 'unknown' : index + 1
}

// Read a numeric field from a tracking-data object, treating missing/non-numeric as 0.
export function getNumericValue(
  data: Record<string, unknown>,
  key: string
): number {
  return Number(data[key]) || 0
}

// What percent `part` is of `total`, guarding divide-by-zero (returns 0).
export function calculatePercentage(
  part: number,
  total: number,
  round: (n: number) => number = Math.round
): number {
  return total > 0 ? round((100 * part) / total) : 0
}

// Concatenate the array-valued `key` from every item and dedupe the result.
export function unionArrayValues(
  items: Array<Record<string, unknown>>,
  key: string
): unknown[] {
  return uniq(
    items.flatMap((item) =>
      Array.isArray(item[key]) ? (item[key] as unknown[]) : []
    )
  )
}
